import {encodeFunctionData} from 'viem';
import type {SupportedCurrency} from 'src/v2/state/types';
import {getAbiForAsset} from 'src/utils/getAbiForAsset';

export const encodePermitFunctionData = ({
  asset,
  owner,
  spender,
  value,
  deadline,
  signature,
}: {
  asset: SupportedCurrency;
  owner: string;
  spender: string;
  value: bigint;
  deadline: bigint;
  signature: string;
}) => {
  return encodeFunctionData({
    abi: getAbiForAsset(asset),
    functionName: 'permit',
    args: [owner, spender, value, deadline, signature],
  });
};
